import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { SkillDetailsFragmentDoc } from '../../../../../../../../skill-matrix/graphql/fragment/generated/SkillDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrgRoleMindsetTrackDetailsFragment = { __typename: 'OrgRoleType', id: string, mindsetIds?: Array<string> | null };


export type OrgRoleMindsetTrackDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TrackDetailsMindsetFragment = { id: string, mindsetIds?: Array<string> | null, mindsets?: Array<{ __typename: 'SkillType', id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null }> | null, orgRoles?: Array<{ __typename: 'OrgRoleType', id: string, mindsetIds?: Array<string> | null }> | null };


export type TrackDetailsMindsetFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TrackDetailsMindsetsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.TrackFilters>;
}>;


export type TrackDetailsMindsetsQuery = { track?: { id: string, mindsetIds?: Array<string> | null, mindsets?: Array<{ __typename: 'SkillType', id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null }> | null, orgRoles?: Array<{ __typename: 'OrgRoleType', id: string, mindsetIds?: Array<string> | null }> | null } | null };

export const OrgRoleMindsetTrackDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment OrgRoleMindsetTrackDetails on OrgRoleType {
  id
  mindsetIds
  __typename
}
    `;
export const TrackDetailsMindsetFragmentDoc = /*#__PURE__*/ gql`
    fragment TrackDetailsMindset on TrackType {
  id
  mindsetIds
  mindsets {
    ...SkillDetails
  }
  orgRoles {
    ...OrgRoleMindsetTrackDetails
  }
}
    `;
export const TrackDetailsMindsetsDocument = /*#__PURE__*/ gql`
    query trackDetailsMindsets($filters: TrackFilters) {
  track(filters: $filters) {
    ...TrackDetailsMindset
  }
}
    ${TrackDetailsMindsetFragmentDoc}
${SkillDetailsFragmentDoc}
${OrgRoleMindsetTrackDetailsFragmentDoc}`;

export function useTrackDetailsMindsetsQuery(options?: Omit<Urql.UseQueryArgs<TrackDetailsMindsetsQueryVariables>, 'query'>) {
  return Urql.useQuery<TrackDetailsMindsetsQuery, TrackDetailsMindsetsQueryVariables>({ query: TrackDetailsMindsetsDocument, ...options });
};